import {Directive, TemplateRef} from '@angular/core';

@Directive({
  selector: '[gcUserGridEditForm]'
})
export class UserGridEditFormDirective {

  constructor(public template: TemplateRef<any>) { }

}
